import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  InputGroup,
  InputLeftAddon
} from '@chakra-ui/react'
import { formatCLPInput } from '../../../utils/currency'

const CurrencyInput = ({
  label,
  value,
  onChange,
  onBlur,
  isInvalid,
  errorMessage,
  placeholder = '0',
  name
}) => {
  const handleChange = (event) => {
    onChange(formatCLPInput(event.target.value))
  }

  return (
    <FormControl isInvalid={isInvalid}>
      {label ? <FormLabel>{label}</FormLabel> : null}
      <InputGroup>
        <InputLeftAddon>$</InputLeftAddon>
        <Input
          name={name}
          value={value}
          onChange={handleChange}
          onBlur={onBlur}
          placeholder={placeholder}
          inputMode="numeric"
        />
      </InputGroup>
      <FormErrorMessage>{errorMessage}</FormErrorMessage>
    </FormControl>
  )
}

export default CurrencyInput
